function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires;
}

const translationNotice = document.querySelector(".automatic-translation-notice");
if (translationNotice) {
    translationNotice
        .querySelector("button")
        .addEventListener("click", (e) => setCookie("hide-automatic-translation-notice", true, 7), { passive: true });
}
